import Vue from 'vue'
import Vuex from 'vuex'

const ID_TOKEN_KEY = 'id_token'
const LOGGED_IN_KEY = 'logged_in'
const COMPANY_ID = 'company_id'
const GRADE_TYPE = 'grade_type'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,

  state: {
    loggedIn: null,
    token: '',
    companyid: '',
    gradetype: 0
  },

  mutations: {
    logout (state) {
      state.loggedIn = false
      state.token = ''
      state.gradetype = 0
      localStorage.removeItem(ID_TOKEN_KEY)
      localStorage.removeItem(LOGGED_IN_KEY)
      localStorage.removeItem(GRADE_TYPE)
    },
    login (state, data) {
      state.loggedIn = true
      state.token = data.t
      state.companyid = data.c
      state.gradetype = data.g
      localStorage.setItem(ID_TOKEN_KEY, data.t)
      localStorage.setItem(COMPANY_ID, data.c)
      localStorage.setItem(LOGGED_IN_KEY, true)
      localStorage.setItem(GRADE_TYPE, data.g)
    },
    initializeStore (state) {
      var tokenKey = localStorage.getItem(ID_TOKEN_KEY)
      var loginkey = localStorage.getItem(LOGGED_IN_KEY)
      var companyKey = localStorage.getItem(COMPANY_ID)
      var gradeKey = localStorage.getItem(GRADE_TYPE)
      state.token = tokenKey
      state.loggedIn = loginkey
      state.companyid = companyKey
      state.gradetype = gradeKey
    }
  },

  date () {

  },

  actions: {
  },
  methods: {
    testtest () {
      return 'aa'
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js